import * as React from "react";
import { Signal } from "../../earth/core/signal";
import { FrameTime } from "../../earth/earthEngine";
import { EarthEngine } from "../../earth/earthEngine";
import { Country } from "../../earth/model/country";
import { LandLevel } from "../../earth/model/land";
import { UIGlobalState } from "./uiGlobalState";

export class UIContext {
    static readonly ContinentAltitude = 2.2;
    static readonly SubContinentAltitude = 1.0;

    shouldSwitchToContext = new Signal<UIContext>();

    get landLevel(): LandLevel {
        let camera = EarthEngine.instance.camera;
        let altitude = camera.altitude;
        if (altitude > UIContext.ContinentAltitude) {
            return LandLevel.Continent;
        }
        if (altitude > UIContext.SubContinentAltitude) {
            return LandLevel.SubContinent;
        }
        return LandLevel.Country;
    }

    get selectedCountry(): Country | null {
        return null;
    }

    enter(from: UIContext) {
    }

    leave(to: UIContext) {
    }

    update(time: FrameTime) {
    }

    render(globalState: UIGlobalState): JSX.Element | null {
        return null;
    }

    onEarthTapped(country: Country | null) {
    }

    onSkyTapped() {
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContext.tsx